<template>
  <div class="user" v-if="user">
    <h1>Пользователь</h1>
    <div class="user-details">
      <p><strong>Имя пользователя:</strong> {{ user.name }}</p>
      <p><strong>Email:</strong> {{ user.email }}</p>
      <p><strong>Роль:</strong> {{ user.role.name }}</p>
      <div class="update-role">
        <p><strong>Назначить Роль:</strong></p>
        <select class="select-wrapper" v-model="selectedRole" >
          <option class="select-arrow" v-for="role in roles" :value="role.id">{{ role.name }}</option>
          
        </select>
      </div>

      <div class="buttons">
        <button class="submit" @click="assignRole">Назначить</button>
        <button class="delete" @click="showConfirmationModal">Удалить</button>
      </div>
    </div>

    <!-- Модальное окно подтверждения удаления -->
    <div class="modal" v-if="showModal">
      <div class="modal-content">
        <h2>Подтвердите удаление</h2>
        <p>Вы уверены, что хотите удалить пользователя?</p>
        <div class="modal-buttons">
          <button @click="deleteUser">Удалить</button>
          <button @click="hideConfirmationModal">Отмена</button>
        </div>
      </div>
    </div>
  </div>
  <div v-else><h2>Нет Данных</h2></div>
</template>

<script>
import { ref, computed } from 'vue'
import { useStore } from 'vuex'
import { useRouter } from 'vue-router'
import { createToaster } from "@meforma/vue-toaster";

export default {
  setup() {
    const store = useStore()
    const router = useRouter()
    const selectedRole = ref(3)

    const users = computed(() => store.state.user.users)
    const id = router.currentRoute.value.params.id
    const user = computed(() => {
      const userList = users.value.filter(user => user.id === id)
      if (userList.length > 0) return userList[0]
    })


    const toaster = createToaster()

    const assignRole = async () => {
      const response = await store.dispatch('updateRole',{user_id:id,role_id:parseInt(selectedRole.value)})
      toaster.success("Данные обновлены")
    }

    const showModal = ref(false)

    const showConfirmationModal = () => {
      showModal.value = true
    }

    const hideConfirmationModal = () => {
      showModal.value = false
    }

    const deleteUser = async () => {
      const response = await store.dispatch('deleteUser',user.value.id)
      if(response){
        toaster.success('Пользователь удален')   
      }else{
        toaster.error("Нет доступа")   
      }
      router.push('/users') 
    }

    return {
      user,
      assignRole,
      showModal,
      showConfirmationModal,
      hideConfirmationModal,
      deleteUser,
      selectedRole,
      roles:computed(()=>store.state.user.roles_title)
    }
  }
}
</script>


<style scoped>
.user {
  max-width: 400px;
  margin: 0 auto;
  padding: 20px;
}

h1 {
  text-align: center;
  font-size: 24px;
  margin-bottom: 20px;
}

.user-details {
  background-color: #f5f5f5;
  padding: 20px;
  border-radius: 4px;
}

.user-details p {
  margin-bottom: 10px;
}

.user-details strong {
  font-weight: bold;
}

.buttons {
  margin-top: 20px;
  display: flex;
  justify-content: center;
}

.buttons button {
  margin: 0 10px;
  padding: 10px 20px;
  color: #fff;
  border: none;
  border-radius: 4px;
  cursor: pointer;
}

.buttons button:hover {
  background-color: #0056b3;
}

/* Стили для модального окна */

.modal {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
}

.modal-content {
  background-color: #fff;
  padding: 20px;
  border-radius: 4px;
}

.modal h2 {
  margin-top: 0;
  font-size: 20px;
  text-align: center;
}

.modal p {
  margin-bottom: 10px;
}

.modal-buttons {
  display: flex;
  justify-content: center;
  margin-top: 20px;
}

.modal-buttons button {
  margin: 0 10px;
  padding: 10px 20px;
  color: #fff;
  background-color: #007bff;
  border: none;
  border-radius: 4px;
  cursor: pointer;
}

.modal-buttons button:hover {
  background-color: #0056b3;
}
.update-role{
  display: flex;
  align-items: center;
/*  justify-content: space-around;*/
}

.update-role p{
  margin: 0;
}

/*select{
  height: 25px;
  width: 100px;
  margin-left: 10px;
}*/

.select-wrapper {
  position: relative;
  display: inline-block;
}

.select-arrow {
  position: absolute;
  top: 50%;
  right: 10px;
  transform: translateY(-50%);
  pointer-events: none;
}

.select-arrow::before {
  content: '';
  display: block;
  width: 0.5em;
  height: 0.5em;
  border-style: solid;
  border-width: 0.1em 0.1em 0;
  border-color: #999 transparent transparent;
  transform: rotate(45deg);
}

select {
  text-align: center;
  margin-left: 10px;
  appearance: none;
  -webkit-appearance: none;
  -moz-appearance: none;
  padding: 0.2em 1em;
  font-size: 14px;
  border: 1px solid #ccc;
  border-radius: 4px;
  background-color: #fff;
}

select:focus {
  outline: none;
  box-shadow: 0 0 3px rgba(0, 0, 0, 0.2);
}

select option {
  font-size: 16px;
}

.submit{
  background-color: #007bff;  
}

.delete{
  background-color: red;
}
</style>
